import * as React from 'react';
import { LockCircleOutlined, UnlockCircleOutlined } from '@easyv/react-icons';
import classnames from 'classnames';

export interface LockIconProp {
  className?: string;
  disabled?: boolean;
  bordered?: boolean;
  onClick?: () => void;
  value?: boolean;
  size?: number;
  onChange?: (value: boolean) => void; // 由Antd托管
}

export function LockIcon({
  value,
  onChange,
  className,
  disabled,
  bordered = false,
  size = 16,
  onClick,
}: LockIconProp) {
  const [locked, setLocked] = React.useState(false);

  React.useEffect(() => {
    setLocked(!!value);
  }, [value]);

  return (
    <div
      className={classnames(
        'cursor-pointer flex items-center justify-center',
        className,
        {
          'border-1 rounded': bordered,
        },
        locked ? 'border-primary' : 'border-borderColorBase',
        disabled ? 'text-content4' : 'text-textColorBase',
      )}
      onClick={() => {
        if (disabled) return;
        onClick?.();
        onChange?.(!locked);
      }}
    >
      {locked ? (
        <LockCircleOutlined className='anticon ' size={size} />
      ) : (
        <UnlockCircleOutlined className='anticon' size={size} />
      )}
    </div>
  );
}
